<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .top-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: utils.in_rem(48px);
    position: relative;

    .back-button {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;

      .icon-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: utils.in_rem(34px);
        width: utils.in_rem(34px);
        padding: utils.in_rem(9px);
        border: 0;
        border-radius: 8px;
        cursor: pointer;
        background-color: transparent;
        color: colors.get(textWhite);
        transition: color 0.2s ease;

        &:hover {
          color: colors.get(interfaceTransparentWhite_70);
        }

        &:focus {
          color: colors.get(interfaceTransparentWhite_70);
          outline: none;
        }

        &:disabled {
          cursor: auto;
          opacity: 0.5;
        }

        i {
          font-size: utils.in_rem(16px);
        }
      }
    }
  }
</style>

<script>
  import DiallerCallDuration from "./DiallerCallDuration.svelte";
  import WarningIcons from "./WarningIcons.svelte";
  import { diallerState } from "../diallerState.svelte";
  import { isExtension } from "../../../../../../env";
  const activeCall = $derived(diallerState.activeCall);
  const extension = $derived(isExtension());

  const handleBack = () => {
    diallerState.viewMode = "keypad-dial";
  };
</script>

<div class="top-row">
  <!-- Only show back button to the host user (not the manager) -->
  {#if !activeCall && extension}
    <div class="back-button">
      <button
        class="icon-button"
        onclick={handleBack}
        type="button"
        aria-label="Back"
      >
        <i class="fa-solid fa-arrow-left"></i>
      </button>
    </div>
  {/if}
  <DiallerCallDuration visible={activeCall} />
  <WarningIcons />
</div>
